module.exports = __webpack_public_path__ + "static/media/geoalt.216789a4.svg";